import React from 'react';

import { Container } from './styles';

import InputMaskSp from '../../../../components/InputMaskSp';

function InputMask(props) {
  const { required, ...rest } = props;

  return (
    <Container required={required}>
      <InputMaskSp className={required ? 'required' : ''} {...rest} />
    </Container>
  );
}

export default InputMask;
